/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'

import { RATE_TABLE_FOOTER_DISCLOSURE } from './const'
import styles from './styles.module.scss'

const Superscript = ({ callback = () => {} }) => {
  const handleSuperscriptClick = () => {
    callback()

    setTimeout(() => {
      try {
        const el = document.getElementById(RATE_TABLE_FOOTER_DISCLOSURE)
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } catch (err) {
        console.error(err)
      }
    }, 100)
  }

  return (
    <sup className={styles.sup} onClick={handleSuperscriptClick}>
      1
    </sup>
  )
}

Superscript.propTypes = {
  callback: PropTypes.func,
}

export default Superscript
